import gql from 'graphql-tag';
const MATH_MASTER_ACTIVITY_FRAGMENT = gql `
  fragment MathMasterActivityFragment on MathMasterActivity {
    rounds {
      answers {
        answer
        isCorrect
      }
      steps {
        answer
      }
    }
  }
`;
export default MATH_MASTER_ACTIVITY_FRAGMENT;
